import PasswordField from './PasswordField'
import { withPasswordField } from './withPasswordField'

const ConnectedInputField = withPasswordField(PasswordField)

export { ConnectedInputField as PasswordField }
